module.exports = __webpack_public_path__ + "public/img/17.6b33d6f4.png";